import type { ComponentProps, ComponentState, ForwardRefComponent, Slot, TabProps } from '@fluentui/react-components';

export type TabSlot = ForwardRefComponent<Partial<TabProps>>;

export type GroundingCommandBarTabSlots = {
  root: NonNullable<Slot<'span'>>;
  tab: NonNullable<Slot<TabSlot>>;
};

/**
 * GroundingCommandBarTab Props
 */
export type GroundingCommandBarTabProps = ComponentProps<Partial<GroundingCommandBarTabSlots>, 'tab'> &
  Pick<TabProps, 'value'>;

/**
 * State used in rendering GroundingCommandBarTab
 */
export type GroundingCommandBarTabState = ComponentState<GroundingCommandBarTabSlots> /*& TabState*/ & {
  value: string;
  selected: boolean;
};
